<div class="transport-routing">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'edit route' | translate: ['tmc.transport.routing.title', translationService.language]}}</h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="transportRouting.carrier" [identifier]="transportRouting.identifier"
        [driver]="transportRouting.name" [scope]="transportRouting.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <form class="form" [formGroup]="form">

        <mat-checkbox name="useAsShuttle" formControlName="useAsShuttle" (ngModelChange)="onModelChanged()"
          *ngIf="shuttleTransportsEnabled">
          {{'change route manually' | translate: ['tmc.transport.routing.routingPosition.use-as-shuttle',
          translationService.language]}}
        </mat-checkbox>

        <button mat-stroked-button class="reload-button" (click)="reloadRoute()">
          <sc-icon iconClass="fa-sync-alt"></sc-icon>
          <span>
            {{'reload route' | translate: ['tmc.transport.routing.action.reload-positions',
            translationService.language]}}
          </span>
        </button>

        <mat-checkbox name="changeRouteManually" formControlName="changeRouteManually"
          [disabled]="transportRouting.changeRouteManually" (ngModelChange)="onModelChanged()">
          {{'change route manually' | translate: ['tmc.transport.routing.routingPosition.change-route-manually',
          translationService.language]}}
        </mat-checkbox>

        <div class="form-box">
          <div class="draggable-form-box margin-bottom20 grid" *ngFor="let position of getNonChangeableRoutings()">

            <div>
              <sc-flex centered>
                <app-routing-position-editor [routingPosition]="position" [disabled]="true"/>
                <button mat-icon-button class="small-button remove-button" [disabled]="true">
                  <sc-icon iconClass="fa-minus"></sc-icon>
                </button>
              </sc-flex>
            </div>

          </div>
        </div>

        <div class="form-box" cdkDropList (cdkDropListDropped)="drop($event)">
          <div class="draggable-form-box grid def" cdkDrag [cdkDragDisabled]="!transportRouting.changeRouteManually"
            *ngFor="let position of getChangeableRoutings()">

            <div>
              <sc-flex centered>
                <app-routing-position-editor [routingPosition]="position" (changed)="positionUpdated(position)" />
                <button mat-icon-button class="small-button remove-button" (click)="removePosition(position)">
                  <sc-icon iconClass="fa-minus"></sc-icon>
                </button>
              </sc-flex>
            </div>

          </div>
        </div>

        <div class="add-button-wrapper">
          <button class="add-button" mat-stroked-button (click)="addPosition()"
            [disabled]="isLoading || !transportRouting.changeRouteManually"><sc-icon iconClass="fa-plus"></sc-icon></button>
        </div>
      </form>
    </div>

    <i class="horizontal-divider"></i>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.routing.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled">{{'save' | translate:
        ['tmc.transport.routing.action.save', translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>
